import React from 'react';
import { PopoverButton as PopoverButtonNew } from './PopoverButton';
import { convertOldPopoverButtonProps } from './converter.old';
import type { OldPopoverButtonProps } from './converter.old';

export type PopoverButtonProps<OptionValue extends string | number> = OldPopoverButtonProps<OptionValue>;

export function PopoverButton<OptionValue extends string | number>(props: PopoverButtonProps<OptionValue>) {
  return <PopoverButtonNew {...convertOldPopoverButtonProps(props)} />;
}
